import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Tooltip, Button, Modal, ModalFooter } from 'react-bootstrap'
import Card from '../Card'
import CustomToggle from '../dropdowns'
import ShareOffcanvas from '../share-offcanvas'
import { Link, useNavigate, Route } from 'react-router-dom'
import Loader from "react-js-loader";
import { apiHandler } from '../../api/apihandler';
import { EVENT_MEMBERS } from "../../api/constants";
import Moment from 'moment';
import { formatEventDate, formatEventTime } from '../../utilities/eventDateTime';
import EventImagePlaceholder from './eventImagePlaceholder';
import ReactFsLightbox from 'fslightbox-react';
import Swal from 'sweetalert2'

// images
import user05 from '../../assets/images/user/05.jpg'
import user06 from '../../assets/images/user/06.jpg'
import user07 from '../../assets/images/user/07.jpg'
import user08 from '../../assets/images/user/08.jpg'
import user09 from '../../assets/images/user/09.jpg'
import EventParticipateModal from './eventParticipateModal'
import ParticipatePaymentPopup from './participatePaymentPopup'
// Fslightbox plugin
const FsLightbox = ReactFsLightbox.default ? ReactFsLightbox.default : ReactFsLightbox;


const EventInvitationPopupCard = ({ elm, getEventList, isPast }) => {
    const navigate = useNavigate();
    const [memberList, setMemberList] = useState([]);
    const [showTicketBuy, setShowTicketBuy] = useState(false);
    const [showParticipateModal, setShowParticipateModal] = useState(false);

    useEffect(() => {
        //getMembersList()
    }, [])

    async function getMembersList() {
        try {
            const res = await apiHandler(EVENT_MEMBERS, "POST", {
                event_id: elm?.id,
                page: 1,
                limit: 6
            })
            if (res.data?.response?.status === 200) {
                setMemberList(res?.data?.data?.eventParticipants?.data)
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    }


    return (
        <>
            {/* <div style={{ width: "33%" }}> */}
            <div>
                <Card className="rounded  mb-0" >
                    <div className="event-images">
                        <Link to={`/dashboards/app/event-detail/${elm?.event?.slug}`}>
                            {elm?.event?.image ? (
                                <img src={elm.event.image}
                                    className="img-fluid" alt="Responsive"
                                    style={{ height: "94px", width: "100%", objectFit: "initial" }} />
                            ) : (
                                <EventImagePlaceholder style={{ height: "94px", width: "100%" }} />
                            )}
                        </Link>
                    </div>
                    <Card.Body>
                        <div style={{ marginTop: "-10px", marginLeft: "-10px", marginRight: "-10px" }}>
                            <div className="d-flex w-100">
                                <div className="events-detail ">
                                    <div className='d-flex align-items-center'>
                                        <h5><Link to={`/dashboards/app/event-detail/${elm?.event?.slug}`}
                                            onClick={() => {
                                                localStorage.setItem('eventIsPast', isPast)
                                            }}>{elm?.event?.name}</Link></h5>
                                        {
                                            isPast ? null :
                                                elm?.payment_status === 1 ?
                                                    <div className='d-flex align-items-center ms-2'>
                                                        <h6 style={{ color: "#20c997" }}><i class="ri-checkbox-circle-line"></i>Paid </h6>
                                                    </div> : null
                                        }
                                    </div>
                                    <div style={{fontSize: "12px"}}>{formatEventDate(elm?.start_date) + " - " + formatEventDate(elm?.end_date)}</div>
                                    <div className="comments date me-4 d-flex align-items-center">
                                        <i className="icon material-symbols-outlined me-1" style={{ fontSize: "15px" }}>schedule</i>
                                        <div style={{fontSize: "12px"}}>{formatEventTime(elm?.start_time) + " - " + formatEventTime(elm?.end_time)}</div>
                                    </div>
                                    {/* <p>{elm?.address}</p> */}
                                    <p>{(elm?.event?.city || '') + ", " + (elm?.event?.state || '') + ", " + (elm?.event?.zip || '')}</p>
                                </div>

                                {/* <div className="card-post-toolbar">
                                    <h5>{"$" + elm?.price}</h5>
                                </div> */}
                            </div>

                            {
                                // No event price means there's nothing to charge -
                                // showing "Pay Now $undefined" would open a payment
                                // popup with no valid amount.
                                isPast ? null :
                                    elm?.payment_status === 0 && elm?.event?.price ?
                                        <div className="d-flex">
                                            <button type="submit" className="btn btn-primary d-block w-100" style={{ marginRight: "0px" }}
                                                onClick={() => {
                                                    if (localStorage.getItem("uzoneAuthToken")) {
                                                        setShowTicketBuy(true)
                                                    } else {
                                                        navigate('/auth/sign-in')
                                                    }
                                                }}
                                            >Pay Now {"$" + elm?.event?.price}</button>
                                        </div> : null
                            }
                        </div>
                    </Card.Body>
                </Card>
                <ParticipatePaymentPopup elm={elm?.event} showTicketBuy={showTicketBuy} setShowTicketBuy={setShowTicketBuy} getEventList={getEventList} />
            </div>
        </>
    )
}

export default EventInvitationPopupCard
